<template>
  <VSlideYReverseTransition>
  </VSlideYReverseTransition>
</template>

<script>
import { SHOW_SUPPORT_POPUP } from '@/store/mutations'
import { DISPLAY_NOTIFICATION } from '@/store/actions'
import loadScript from '@/utils/loadScript'
import runDelayedMixin from '@/mixins/runDelayedMixin'

export default {
  name: 'SupportPopup',

  mixins: [runDelayedMixin],

  data() {
    return {
      loading: false,
    }
  },

  computed: {
    user() {
      return this.$store.getters.user
    },

    show: {
      get() {
        return this.$store.state.showSupportPopup
      },
      set(value) {
        this.$store.commit(SHOW_SUPPORT_POPUP, { show: value })
      },
    },
  },

  watch: {
    show(next, previous) {
      if (next === previous) return
      if (next) {
        this.onOpenZendesk()
      }
    },
  },

  methods: {
    async onOpenZendesk() {
      console.log(this.$store.getters.currentPlan.name)
      Beacon('identify', {
        username: this.user.username,
        email: this.user.email,
        plan: this.$store.getters.currentPlan.name
      })

      Beacon('prefill', {
        name: this.user.username,
        email: this.user.email
      })

      return Beacon('open')
    },
  }
}
</script>

<style lang="postcss" scoped>
.support-popup-component {
  position: fixed;
  bottom: 16px;
  right: 16px;

  /* Above the KPIDashboardPage/ComponentPicker component */
  z-index: 203;

  display: flex;
  flex-direction: column;
  align-items: center;

  /* Zendesk style */
  width: 342px;
  background-color: #fbfbfb;
  color: #2f3941;
  border-radius: 0.57143rem;
}
</style>

<style lang="postcss">
.zEWidget-webWidget.zEWidget-webWidget--active {
  right: 0 !important;
  left: auto !important;
}
</style>
